<template>
    <div class="recommend" v-if="Array.isArray(baseData) && baseData.length">
        <div class="title pl12">
            产品推荐
        </div>

        <div class="list" @scroll.once="eventTrack('SCROLL_INDEX_RECOMMEND')">
            <ul>
                <card
                    :form="form"
                    :key="i"
                    v-for="(form, i) in baseData">
                </card>
            </ul>
        </div>
    </div>
</template>

<script>
    import Card from './Card.vue';
    import {eventTrack} from '@/business/analy';

    export default {

        props: {
            baseData: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },

        computed: {
        },

        components: {
            Card
        },
        methods: {
            eventTrack
        }
    }

</script>

<style lang="scss">
@import '../../style/common.scss';

.recommend {
    margin: 9px 0 1px;
    padding: 0 13px;
    .title {
        position: relative;
        height: 40px;
        font-size: 18px;
        line-height: 40px;
        color: $fontStrongColor;
    }
    .list {
        padding-right: 0;
        padding-bottom: 8px;
        ul {
            @include clearfix;
            margin-left: -7px;
            @supports (display: grid) {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-column-gap: 7px;
                grid-row-gap: 14px;
                margin-left: 0;
            }
            li {
                float: left;
                width: 50%;
                box-sizing: border-box;
                padding-left: 7px;
                padding-bottom: 14px;
                @supports (display: grid) {
                    float: none;
                    width: auto;
                    padding-left: 0;
                    padding-bottom: 0;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue